export default __webpack_public_path__ + "static/media/preloader.c7d9f081.gif";